import { createFileRoute } from '@tanstack/react-router'
import { MaterialIssueDetailPage } from '../../../../features/projects/material-issue-pages'

export const Route = createFileRoute('/_app/projects/material-issues/$issueId')({
  component: MaterialIssueDetailPage,
})
